import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import ReactModal from 'react-modal';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import Dropzone from 'react-dropzone';
import ImageUpload from '../image-upload';

import config from 'client/shared/config';


const styles = {
	modal: {
		overlay : {
			position          : 'fixed',
			top               : 0,
			left              : 0,
			right             : 0,
			bottom            : 0,
			backgroundColor   : 'rgba(0, 0, 0, 0.8)'
		},
		content : {
			position                   : 'absolute',
			top                        : '10%',
			left                       : '10%',
			right                      : '10%',
			bottom                     : 'auto',
			border                     : '1px solid #ccc',
			background                 : 'rgba(255, 255, 255, .975)',
			overflow                   : 'auto',
			WebkitOverflowScrolling    : 'touch',
			borderRadius               : '0',
			outline                    : 'none',
			padding                    : '20px',
		    maxHeight				   : '55rem',
			color					   : '#0a0a0a'
		}
	}
};

class ActionComp extends Component {
	render () {
		const {
			imgSrc,
			imgPath,
			onDrop,
			onClick,
			fullWidth,
			imgClassName,
			imgBasePath = config.paths.profileImgBasePath
		} = this.props;


		if (_.isEmpty(imgSrc)) {

			return (
				<Dropzone onDrop={ onDrop } className={ `drop-zone${ fullWidth ? ' full-width' : '' }` }>
					{/* <span className="fas fa-image"></span>
					<br />
					<strong>
						Drag &amp; drop your .jpg/.jpeg or .png files
						<br />
						or click here.
					</strong> */}
					{
					() => (
						<Fragment>
							<span className="fas fa-image"></span>
							<br />
							<strong>
								Drag &amp; drop your .jpg/.jpeg or .png files
								<br />
								or click here.
							</strong>
						</Fragment>
					)
				}
				</Dropzone>
			);
		}

		const styles = {
			backgroundImage: `url(${ (/^data/).test(imgSrc) ? imgSrc : imgPath })`
		};

		return (
			<div className={ `edit-image ${imgClassName}` } style={ styles } onClick={ onClick }></div>
		);
	}
}

@observer
class EditImage extends Component {
	constructor (props) {
		super(props);

		this.state = {
			imgSrc: this.props.imgSrc,
			imageEditModalOpen: false
		};
	}

	render () {
		const {
			store,
			height = 400,
			width = 400,
			aspectRatio = 1,
			buttonText = 'Upload Image',
			fullWidth = false,
			alwaysShowUpload = false,
			imgClassName = 'image medium',
			imgBasePath = config.paths.imgBasePath

		} = this.props;

		const { imgSrc, imageEditModalOpen } = this.state;
		const imgPath = _.isEmpty(imgSrc) ? '' : `${_.compact([imgBasePath, imgSrc]).join('/')}`;

		return (
			<div className={`image-wrapper${ fullWidth ? 'full-width' : '' }`}>
				<ReactModal
					isOpen={ imageEditModalOpen }
					contentLabel="Edit Image"
					shouldCloseOnOverlayClick={ true }
					className={{
						base: 'modal',
						afterOpen: 'modal-after-open',
						beforeClose: 'modal-before-close'
					}}
					overlayClassName={{
						base: 'modal-overlay',
						afterOpen: 'modal-overlay-after-open',
						beforeClose: 'modal-overlay-before-close'
					}}
				>
					<ImageUpload
						imgSrc={ imgSrc }
						imgPath={ imgPath }
						store={ store }
						height={ height }
						width={ width }
						aspectRatio={ aspectRatio }
						imgClassName={ imgClassName }
						handleImageCrop={ this.handleImageCrop }
					>
						<button className="button clear secondary padding-left-0" onClick={ this.handleCloseModal }>
							<span className="fas fa-window-close"></span> Close Modal
						</button>
					</ImageUpload>
				</ReactModal>

				<ActionComp
					fullWidth
					onDrop={ this.onDrop }
					onClick={ this.handleOpenModal }
					imgClassName={ imgClassName }
					imgSrc={ alwaysShowUpload ? '' : imgSrc }
					imgPath={ imgPath }
					buttonText={ buttonText } />
			</div>
		);
	}

	@autobind
	handleImageCrop (cropResult) {
		const { handleImageCrop = _.noop } = this.props;

		this.setState({
			imgSrc: cropResult
		});

		handleImageCrop(cropResult);

		this.handleCloseModal();
	}

	@autobind
	handleOpenModal () {
		this.setState({
			imageEditModalOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			imageEditModalOpen: false
		});
	}

	@autobind
	onDrop (file) {
		this.props.store.set({
			key: 'editImage.uploadImage',
			value: file
		});

		this.handleOpenModal();
	}
}

// Wrap the component to inject dispatch and state into it
export default EditImage;
